import React from 'react';
import { Trans } from 'react-i18next';
import theme from 'src/styles/theme';
import { SongInsights } from '../../Dashboard';

// 1. Momentum card content logic
export const getMomentumCardContent = (
  songInsights: SongInsights,
  isHovering = false
): React.ReactNode => {
  const momentumData = songInsights?.songInsightsData?.momentum;
  if (!momentumData) return null;
  const { difference, category } = momentumData;
  // format difference to have only one decimal place
  const formattedDifference = difference.toFixed(1);

  if (isHovering) {
    if (category === 'positive') {
      return (
        <Trans
          i18nKey="MOMENTUM_HOVER_POSITIVE"
          components={{ bold: <strong /> }}
        />
      );
    }
    if (category === 'stagnant' || category === 'negative') {
      return (
        <Trans
          i18nKey="MOMENTUM_HOVER_NEGATIVE"
          components={{ bold: <strong /> }}
        />
      );
    }
  }
  if (category === 'positive') {
    return (
      <Trans
        i18nKey="MOMENTUM_POSITIVE_GROWTH"
        values={{ number: formattedDifference }}
        components={{
          bold: <strong />,
          color: <span style={{ color: theme.colors.success60 }} />,
        }}
      />
    );
  }
  if (category === 'stagnant') {
    return (
      <Trans i18nKey="MOMENTUM_STAGNANT" components={{ bold: <strong /> }} />
    );
  }
  if (category === 'negative') {
    return (
      <Trans
        i18nKey="MOMENTUM_NEGATIVE_GROWTH"
        values={{ number: 10 }}
        components={{
          bold: <strong />,
          color: <span style={{ color: theme.colors.error50 }} />,
        }}
      />
    );
  }
  return null;
};
